import { InputAdornment, TextField, Grid } from "@material-ui/core";
import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { getDecimalFormat } from "helpers/getNumberFormats";
import { formatNumber } from "helpers/getNumberFormats";

export const FinalNumbers = ({block}) => {
  const { settlement } = useSelector((state) => state.routesStatus);
  const [gasBonusTotal, setGasBonusTotal] = useState(0)
  const {
    gasMovements,
    creditAmount,
    cashAmount,
    total,
    totalKilosSold,
    totalLitersSold,
    notes
  } = settlement;

  useEffect(() => {
    if(notes) setGasBonusTotal(notes.reduce((acc, curr) => acc += curr?.gasBonus || 0, 0))
  }, [notes])
  
  const isLts = settlement?.unit?.type?.toLowerCase().includes("estacion");

  return (
    <>
      {!block && (
        <Grid item xs={12} md={2}>
          <TextField
            label="Kilos Totales a Reportar"
            margin="dense"
            variant="outlined"
            fullWidth
            // type="number"
            name="kgsT"
            value={formatNumber(settlement?.totalReport)}
            disabled
            InputProps={{
              inputProps: {
                right: "1",
                min: 0, 
              }
            }}
          />
        </Grid>
      )}
      <Grid item xs={12} md={2}>
        <TextField
          // type="number"
          variant="outlined"
          fullWidth
          margin="dense"
          label="Bonificación de Gas:"
          value={
            // gasBonusTotal
            isLts
              ? gasMovements?.totalQuantityInLt?.toFixed(2)
              : gasMovements?.totalQuantityInKg?.toFixed(2)
          }
          InputProps={{
            endAdornment: (
              <InputAdornment position="end">{isLts ? 'Lts' : 'Kgs'}</InputAdornment>
            ),
            inputProps: {
              right: "1",
            }
          }}
          disabled
        />
      </Grid>
      <Grid item xs={12} md={2}>
        <TextField
          // type="number"
          variant="outlined"
          fullWidth
          margin="dense"
          label="Credito:"
          value={formatNumber(creditAmount)}
          disabled
          InputProps={{
            startAdornment: <InputAdornment position="start">$</InputAdornment>,
            inputProps: {
              right: "1",
            },
          }}
        />
      </Grid>

      {/* <Grid item xs={12} sm={isLts ? 3 : 2}> */}
      <Grid item xs={12} md={2}>
        <TextField
          // type="number"
          variant="outlined"
          fullWidth
          margin="dense"
          label="Contado:"
          value={cashAmount?.toFixed(2)}
          disabled
          InputProps={{
            startAdornment: <InputAdornment position="start">$</InputAdornment>,
            inputProps: {
              right: "1",
            },
          }}
        />
      </Grid>
      <Grid item xs={12} md={2}>
        <TextField
          // type="number"
          variant="outlined"
          fullWidth
          margin="dense"
          label={isLts ? "Lts Totales:" : "Kgs Totales:"}
          value={
            isLts
              ? formatNumber(totalLitersSold) || totalLitersSold
              : formatNumber(totalKilosSold) || totalKilosSold
          }
          InputProps={{
            inputProps: {
              right: "1",
            }
          }}
          disabled
        />
      </Grid>

      <Grid item xs={12} md={2}>
        <TextField
          // type="number"
          variant="outlined"
          margin="dense"
          label="Por pagar:"
          value={total?.toFixed(2)}
          disabled
          fullWidth
          // helperText={totalDiscountNotes > 0 ? <Typography variant="body1" style={{
          //   color: green[500],
          //   textAlign: 'end'
          // }}>Descuento Total: ${getDecimalFormat(totalDiscountNotes.toFixed(2))}</Typography>: ''}
          InputProps={{
            startAdornment: <InputAdornment position="start">$</InputAdornment>,
            inputProps: {
              right: "1",
            },
          }}
        />
      </Grid>
    </>
  );
};
